<template>
  <el-input :value="value" v-bind="$attrs" :placeholder="placeholder" onmousewheel="return false;" @input="onInput" @change="handleChange">
    <slot slot="prepend" name="prepend" />
    <slot slot="prefix" name="prefix" />
    <slot slot="append" name="append" />
    <slot slot="suffix" name="suffix" />
  </el-input>
</template>

<script>
import debounce from '@/utils/debounce.js'

export default {
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    max: {
      type: Number,
      default: Math.pow(10, 10) - 1
    },
    min: {
      type: Number,
      default: 1
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    isNum: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
      this.authInputValue(value)
    },
    authInputValue: debounce(
      function(value) {
        const { min, max } = this
        if (!value && value !== 0) {
          this.$emit('input', '')
          return
        }
        if (isNaN(value)) {
          this.$emit('input', '')
          this.alertTips('输入值只能为数字！')
          return
        } else {
          const res = this.isNum ? +value : value
          this.$emit('input', res)
        }
        if (!Number.isInteger(+value)) {
          this.$emit('input', '')
          this.alertTips('只能输入整数！')
          return
        }
        // 值不能小于 min
        if (+value < min) {
          this.$emit('input', '')
          this.alertTips(`输入值不能小于${min}！`)
          return
        }
        // 值不能大于max
        if (+value > max) {
          this.$emit('input', '')
          this.alertTips(`输入值不能大于${max}！`)
          return false
        }
      },
      1000
    ),
    alertTips(msg) {
      this.$message.warning(msg)
    },
    handleChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
